<template>
  <main>
    <div class="col-md-12">
      <h4>{{ getTittle() }}</h4>
      <div class="row">
        <div class="col-12" v-if="itemSelected == 7">
          <div class="float-right">
            <button
              class="text-center btn btn-primary mb-2"
              @click="generateTabs()"
            >
              Generate 30 Tabs
            </button>
          </div>
        </div>

        <!-- DomainList -->
        <template v-if="itemSelected === 8">
          <DomainList :condition="'all_inactive'" />
        </template>

        <div class="col-sm-12">
          <small
            class="badge small badge-primary cursor-pointer mb-3 p-2"
            @click="openModal('videotraining')"
            v-if="itemSelected == 7"
            >Tutorial MS Blocked SPAM</small
          >

          <Modal :name="'videotraining'">
            <div class="embed-responsive embed-responsive-16by9">
              <!-- <iframe v-if="false" class="embed-responsive-item" src="https://www.youtube.com/embed/CrMAy18VRg4"
                      allowfullscreen></iframe> -->
              <VideoToolToy
                :url="'https://www.loom.com/embed/8a6278085d644e42b1373bb0d10d865e?sid=d25ece06-579e-4423-aa00-32fbd34605a7'"
                :autoplay="false"
              />
            </div>
          </Modal>

          <div v-if="itemSelected < 8">
            <div v-if="!completeLoading">
              <LoadingSpinner />
            </div>
            <div v-if="completeLoading && itemSelected == 5" class="card p-2 text-left">
              <p>
                <strong>Zapmail Wallet Balance:</strong>
                <strong :class="walletBalance < 300 ? 'badge badge-danger ml-2' : 'badge badge-success ml-2'">$ {{ walletBalance }}</strong>
              </p>
              <p>
                <strong>Microsoft Unassigned Mailboxes ({{ PlanType }} Plan):</strong>
                <strong :class="microsoftUnassigned < 36 ? 'badge badge-danger ml-2' : 'badge badge-success ml-2'">{{ microsoftUnassigned }}</strong>
              </p>
              <div class="mt-2">
                <button
                  type="button"
                  class="btn btn-sm mr-1 mb-1"
                  :class="mailboxCreationFilter === 'all' ? 'btn-dark' : 'btn-outline-dark'"
                  @click="mailboxCreationFilter = 'all'"
                >
                  All ({{ mailboxFilterCounts.all }})
                </button>
                <button
                  type="button"
                  class="btn btn-sm mr-1 mb-1"
                  :class="mailboxCreationFilter === 'retrying' ? 'btn-warning' : 'btn-outline-warning'"
                  @click="mailboxCreationFilter = 'retrying'"
                >
                  Retrying ({{ mailboxFilterCounts.retrying }})
                </button>
                <button
                  type="button"
                  class="btn btn-sm mr-1 mb-1"
                  :class="mailboxCreationFilter === 'exhausted' ? 'btn-danger' : 'btn-outline-danger'"
                  @click="mailboxCreationFilter = 'exhausted'"
                >
                  Exhausted ({{ mailboxFilterCounts.exhausted }})
                </button>
                <button
                  type="button"
                  class="btn btn-sm mr-1 mb-1"
                  :class="mailboxCreationFilter === 'abandoned' ? 'btn-secondary' : 'btn-outline-secondary'"
                  @click="mailboxCreationFilter = 'abandoned'"
                >
                  Abandoned ({{ mailboxFilterCounts.abandoned }})
                </button>
              </div>
            </div>
            <div v-if="completeLoading" class="card my-2">
              <table
                class="w-100 table table-hover bg-white"
                v-if="itemSelected < 8"
              >
                <thead class="thead-dark border-0">
                  <td width="50px" class="border-0"></td>
                  <template v-if="itemSelected == 3">
                    <td class="border-0">Blocked since</td>
                    <td class="border-0">Blocked days 14d / 30d</td>
                    <td class="border-0">Last block</td>
                  </template>
                  <td v-else width="50px" class="border-0">Time</td>
                  <td class="border-0">Workspace</td>

                  <td v-if="itemSelected == 1" class="border-0">Type</td>
                  <td class="border-0">Email</td>
                  <td v-if="itemSelected == 5" class="border-0">Actions</td>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in displayedList" :key="index">
                    <td>
                      {{ index + 1 }}
                    </td>

                    <template v-if="itemSelected == 3">
                      <td>{{ row.blocked_since }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="row.blocked_days_14 >= 7 ? 'badge-danger' : 'badge-warning'"
                        >
                          {{ row.blocked_days_14 }} / {{ row.blocked_days_30 }}
                        </span>
                        <span
                          v-if="row.blocked_days_14 >= 7"
                          class="badge badge-dark ml-1"
                        >
                          Chronic
                        </span>
                      </td>
                      <td>{{ row.last_blocked }}</td>
                    </template>
                    <td v-else>
                      <span
                        v-if="row.task_open_hours !== null"
                        class="badge"
                        :class="taskOpenHoursClass(row.task_open_hours)"
                      >
                        {{ row.task_open_hours }} h
                      </span>
                    </td>

                    <td>
                      {{ row.workspace }}
                      <div v-if="itemSelected == 5">
                        <span
                          v-if="row.creation_status && row.creation_status !== 'ok'"
                          class="badge mr-1"
                          :class="creationStatusClass(row.creation_status)"
                        >
                          {{ row.creation_status }}
                          <template v-if="row.error_attempts && !isNonAttemptWait(row)">
                            · {{ row.error_attempts }} attempts
                          </template>
                        </span>
                        <span
                          v-if="quotaReleaseLabel(row)"
                          class="badge badge-info mr-1"
                        >
                          {{ quotaReleaseLabel(row) }}
                        </span>
                        <small
                          v-if="row.error !== undefined && row.error !== null && row.error !== ''"
                          class="text-danger d-block"
                          >{{ row.error }}</small
                        >
                        <small
                          v-if="row.deletion_in_progress > 0"
                          class="text-muted d-block"
                        >
                          {{ row.deletion_in_progress }} mailbox(es) in last Zapmail deletion batch
                        </small>
                        <small
                          v-if="mailboxWaitMessage(row)"
                          :class="mailboxWaitClass(row)"
                          class="d-block"
                        >
                          {{ mailboxWaitMessage(row) }}
                        </small>
                      </div>
                    </td>
                    <td v-if="itemSelected == 1">
                      {{ row.sync_type }}
                    </td>
                    <td>
                      <span class="mr-2"> {{ row.nylas_email_sync }}</span>
                      <span
                        v-if="
                          row.spark_email_sync_status == 1 && itemSelected != 7
                        "
                        @click="openEmails(row.id, 100, 0)"
                        class="badge-success badge text-white cursor-pointer"
                        ><i class="icon-mail mr-1"></i>Synced</span
                      >
                      <span
                        v-if="
                          row.spark_email_sync_status == 0 &&
                          itemSelected !== 4 &&
                          itemSelected != 7 &&
                          row.workspace != 'ZM-MICROSOFT' &&
                          row.workspace != 'ZM-GOOGLE'
                        "
                        @click="connect(row)"
                        class="badge btn-danger cursor-pointer"
                      >
                        <i class="icon-arrow-circle-o-right mr-1"></i> Sync now
                      </span>

                      <!-- v-if="row.workspace == 'ZM-MICROSOFT' || row.workspace == 'ZM-GOOGLE'" -->
                      <span
                        class="badge btn-danger cursor-pointer"
                        v-if="
                          row.workspace == 'ZM-MICROSOFT' ||
                          row.workspace == 'ZM-GOOGLE'
                        "
                        @click="openModalZapmail(row.id)"
                      >
                        <i class="icon-arrow-circle-o-right mr-1"></i> Sync now
                      </span>

                      <span
                        v-if="
                          row.spark_email_sync_status != 0 && itemSelected == 7
                        "
                        @click="openEmails(row.id, 100, 0)"
                        class="badge-success badge text-white cursor-pointer"
                        ><i class="icon-mail mr-1"></i>Synced</span
                      >
                      <span
                        v-if="
                          row.spark_email_sync_status == 0 && itemSelected == 7
                        "
                        @click="connectSpark(row)"
                        class="badge btn-danger cursor-pointer"
                      >
                        <i class="icon-arrow-circle-o-right mr-1"></i> Sync now
                        {{ row.provider }}
                        <small
                          v-if="row.client_status_id == '4'"
                          class="badge badge-success"
                          >client active</small
                        >
                        <small
                          v-if="row.client_status_id == '3'"
                          class="badge badge-primary"
                          >client prepearing</small
                        >
                        <small
                          v-if="row.client_status_id == '5'"
                          class="badge badge-warning"
                          >client stand by</small
                        >
                      </span>
                      <span
                        class="badge btn-warning ml-2"
                        v-if="
                          [1, 2].includes(itemSelected) && row.queue_emails > 0
                        "
                        ><small
                          >QUEUE EMAILS: {{ row.queue_emails }}</small
                        ></span
                      >

                      <span
                        class="badge ml-2"
                        :class="
                          row.owarm_paused_status == 'blockedspam'
                            ? 'btn-warning'
                            : 'btn-secondary'
                        "
                        v-if="itemSelected == 3"
                        ><small>{{ row.owarm_paused_status }}</small> /
                        <small>{{ row.owarm_paused_status_date }}</small></span
                      >
                    </td>
                    <td v-if="itemSelected == 5">
                      <template v-if="isFirstDomainRow(row, index)">
                        <button
                          v-if="
                            row.creation_status === 'exhausted' ||
                            row.creation_status === 'abandoned'
                          "
                          type="button"
                          class="btn btn-sm btn-primary mr-1 mb-1"
                          :disabled="!!domainActionBusy[row.domain]"
                          @click="retryDomainCreation(row.domain)"
                        >
                          Retry
                        </button>
                        <button
                          v-if="row.creation_status === 'exhausted'"
                          type="button"
                          class="btn btn-sm btn-outline-secondary mb-1"
                          :disabled="!!domainActionBusy[row.domain]"
                          @click="abandonDomainCreation(row.domain)"
                        >
                          Abandon
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- itemSelected >= 8 -->

          <!-- LandingPage -->
          <template v-if="itemSelected === 10">
            <AgencyLandingPageList />
          </template>

          <!-- Delete Domains -->
          <template v-if="itemSelected === 11">
            <DeleteDomainList :condition="'all_inactive'" />
          </template>

          <!-- Domains to buy -->
          <template v-if="itemSelected === 12">
            <AgencyBuyDomain />
          </template>

          <!-- Target Missing Data -->
          <template v-if="itemSelected === 13">
            <TargetMissingData />
          </template>

          <!-- List of target notes -->
          <template v-if="itemSelected === 18">
            <ListTargetNotes />
          </template>

          <!-- Owarm List -->
          <template v-if="itemSelected === 16">
            <OwarmList />
          </template>

          <!-- Commercial without prospectors -->
          <template v-if="itemSelected === 17">
            <CommercialWithoutProspectors />
          </template>

          <!-- Config SMTP -->
          <template v-if="itemSelected === 22">
            <ConfigSmtp @updateConfigSmtpTotal="updateConfigSmtpTotal" />
          </template>

          <!-- Client without Sales -->
          <template v-if="itemSelected === 23">
            <ClientWithoutOliverSales />
          </template>

          <!-- <Not Prospecting Sales />  -->
          <template v-if="itemSelected === 24">
            <NotProspectingSales />
          </template>

          <!-- Contact Supply -->
          <template v-if="itemSelected === 14">
            <ContactSupply :oliver_sale_id="oliver_sale_id" />
          </template>

          <!-- Missing client AM -->
          <template v-if="itemSelected === 26">
            <ClientAttribution />
          </template>

          <!-- Burned Domains -->
          <template v-if="itemSelected === 27">
            <BurnedDomains />
          </template>

          <!-- PhoneLookup -->
          <template v-if="itemSelected === 28">
            <PhoneLookup />
          </template>

          <!-- Order Slowing Down -->
          <template v-if="itemSelected === 29">
            <OrderSlowingDown />
          </template>
        </div>
      </div>
    </div>
    <Modal
      class="mb-2 zapmail-modal-fixed"
      name="zapmailVerificationModal"
      :size="'560px'"
      :close="false"
    >
      <div
        class="modal-content m-5"
        style="max-width: 465px; margin-bottom: 300px"
      >
        <div class="modal-header position-relative mt-4" v-if="userZapmail">
          <h2
            style="z-index:99; position: absolute; right: -9px; top: -39px; padding-right: 1rem; padding-top: 1rem;"
            @click="closeZapmailModal"
          >
            <i class="icon-close cursor-pointer"></i>
          </h2>
          <h6 class="text-center ml-4">
            {{ userZapmail.nylas_email_sync }}
          </h6>
          <button
            @click="copyClipboard(userZapmail.nylas_email_sync)"
            class="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
            style="width: 30px; height: 30px; position: absolute; right: 45px; top: 15px"
            title="Copy code"
          >
            <i class="i icon-copy"></i>
          </button>
        </div>
        <div class="text-center py-5" v-if="zapLoading">
          <LoadingSpinner class="mx-auto" style="width: 150px; height: 150px" />
        </div>
        <div class="my-4" v-else>
          <div
            v-if="codeReady"
            class="modal-body mx-auto"
            style="max-width: 275px"
          >
            <div class="mb-4">
              <div class="text-muted mb-0">Microsoft Auth Code</div>
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <h1
                    class="mb-0 mr-3 font-weight-bold"
                    style="font-size: 2.8rem; letter-spacing: 0.1em"
                  >
                    {{ otp_code }}
                  </h1>
                  <button
                    @click="copyClipboard(otp_code)"
                    class="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
                    style="width: 40px; height: 38px"
                    title="Copy code"
                  >
                    <i class="i icon-copy"></i>
                  </button>
                </div>
              </div>
              <div
                class="text-primary font-weight-bold"
                :class="{
                  'text-danger animate__animated animate__flash':
                    seconds_to_expire <= 10 && seconds_to_expire > 0,
                }"
                style="font-size: 1.4rem; margin-left: 200px"
              >
                {{ seconds_to_expire }}s
              </div>
            </div>

            <!-- Password Section -->
            <div class="mb-5">
              <div class="text-muted mb-2">{{ $t("lang.label.password") }}</div>
              <div class="input-group" style="max-width: 270px">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control form-control-sm"
                  :value="password_zapmail"
                  readonly
                  style="background: white; max-width: 189px"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-secondary btn-sm"
                    @click="showPassword = !showPassword"
                    :title="showPassword ? 'Hide password' : 'Show password'"
                    type="button"
                  >
                    <i class="icon-eye"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-secondary"
                    @click="copyClipboard(password_zapmail)"
                    title="Copy password"
                    type="button"
                  >
                    <i class="icon-copy"></i>
                  </button>
                </div>
              </div>
            </div>
            <button :class="showAdminDetails ? 'btn btn-sm btn-danger mb-3' : 'btn btn-sm btn-success mb-3'" @click="toggleAdminDetails">
              <i class="icon-eye"></i> {{ showAdminDetails ? 'Hide Admin Details' : 'Show Admin Details' }}
            </button>
            <div class="mb-4" v-if="showAdminDetails">
              <div v-if="adminLoading" class="text-center py-4">
                <LoadingSpinner class="mx-auto" style="width: 100px; height: 100px" />
              </div>
              <div v-else-if="!isAdminDataAvailable" class="text-center py-4">
                <span class="text-muted">Admin details are not available</span>
              </div>
              <div v-else>
                <div class="text-muted mb-2">Admin Details</div>
                <div class="input-group mb-3" style="max-width: 270px">
                  <input
                    v-if="adminEmail"
                    type="text"
                    class="form-control form-control-sm"
                    :value="adminEmail"
                    :title="adminEmail"
                    readonly
                    style="background: white; max-width: 215px"
                  />
                  <span v-else class="form-control form-control-sm text-muted d-flex align-items-center" style="background: white; max-width: 215px; border: 1px solid #ced4da; min-height: 31px;">
                    Admin email is not available
                  </span>
                  <div class="input-group-append" v-if="adminEmail">
                    <button
                      class="btn btn-sm btn-secondary"
                      @click="copyClipboard(adminEmail)"
                      title="Copy email"
                      type="button"
                    >
                      <i class="icon-copy"></i>
                    </button>
                  </div>
                </div>
                <div class="input-group mb-4" style="max-width: 270px">
                  <input
                    v-if="adminPassword"
                    :type="showPasswordAdmin ? 'text' : 'password'"
                    class="form-control form-control-sm"
                    :value="adminPassword"
                    readonly
                    style="background: white; max-width: 189px"
                  />
                  <span v-else class="form-control form-control-sm text-muted d-flex align-items-center" style="background: white; max-width: 189px; border: 1px solid #ced4da; min-height: 31px;">
                    Admin password is not available
                  </span>
                  <div class="input-group-append" v-if="adminPassword">
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      @click="showPasswordAdmin = !showPasswordAdmin"
                      :title="showPasswordAdmin ? 'Hide password' : 'Show password'"
                      type="button"
                    >
                      <i class="icon-eye"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-secondary"
                      @click="copyClipboard(adminPassword)"
                      title="Copy password"
                      type="button"
                    >
                      <i class="icon-copy"></i>
                    </button>
                  </div>
                </div>

                <!-- Admin Auth Code -->
                <div>
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <h1
                        v-if="adminOtpCode"
                        class="mb-0 mr-3 font-weight-bold"
                        style="font-size: 2.8rem; letter-spacing: 0.1em"
                      >
                        {{ adminOtpCode }}
                      </h1>
                      <span v-else class="text-muted mr-3">Admin auth code is not available</span>
                      <button
                        v-if="adminOtpCode"
                        @click="copyClipboard(adminOtpCode)"
                        class="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
                        style="width: 40px; height: 38px"
                        title="Copy code"
                      >
                        <i class="i icon-copy"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    v-if="adminOtpCode"
                    class="text-primary font-weight-bold"
                    :class="{
                      'text-danger animate__animated animate__flash':
                        adminSecondsToExpire <= 10 && adminSecondsToExpire > 0,
                    }"
                    style="font-size: 1.4rem; margin-left: 200px"
                  >
                    {{ adminSecondsToExpire }}s
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!zapLoading"
          class="modal-footer align-items-center justify-content-center"
        >
          <button
            class="btn btn-danger cursor-pointer"
            @click="connect(userZapmail)"
          >
            <i class="icon-arrow-circle-o-right mr-1"></i> Sync now
          </button>
        </div>
      </div>
    </Modal>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
import AgencyLandingPageList from "@/components/Agencies/AgencyLandingPageList.vue";
import AgencyBuyDomain from "@/components/Agencies/AgencyBuyDomain.vue";
import DomainList from "@/components/Dashboard/DomainList.vue";
import DeleteDomainList from "@/components/Dashboard/DeleteDomainList.vue";
import TargetMissingData from "@/components/Campaigns/TargetMissingData.vue";
import ListTargetNotes from "@/components/Targets/ListTargetNotes.vue";
import ConfigSmtp from "@/components/Emails/ConfigSmtp.vue";
import ClientWithoutOliverSales from "@/components/Agencies/ClientWithoutOliverSales.vue";
import Modal from "@/components/Common/Modal.vue";
import VideoToolToy from "@/components/Onboarding/VideoToolToy.vue";
import OwarmList from "@/components/Agencies/OwarmList.vue";
import CommercialWithoutProspectors from "@/components/Configuration/CommercialWithoutProspectors.vue";
import ContactSupply from "@/components/Agencies/ContactSupply.vue";
import NotProspectingSales from "@/components/Configuration/NotProspectingSales.vue";
import ClientAttribution from "@/components/Configuration/ClientAttribution.vue";
import BurnedDomains from "@/components/Configuration/BurnedDomains.vue";
import PhoneLookup from "@/components/Configuration/PhoneLookup.vue";
import OrderSlowingDown from "@/components/Configuration/OrderSlowingDown.vue";
import { mapActions } from "vuex";
import {
  adminService,
  usersService,
  workspaceService,
  targetsService,
  monitorService,
} from "@/_services";

export default {
  data() {
    return {
      adminSync: {},
      microsoftUnassigned: null,
      walletBalance: null,
      PlanType: null,
      adminOtpCode: "",
      adminSecondsToExpire: 0,
      adminExpireTimer: null,
      otp_code: "",
      seconds_to_expire: 0,
      password_zapmail: "",
      zapLoading: false,
      codeReady: false,
      expireTimer: null,
      userZapmail: null,
      isModalOpen: false,
      showPassword: false,
      showPasswordAdmin: false,
      showAdminDetails: false,
      adminLoading: false,
      noteStatus: 0,
      itemSelected: 2,
      totals: {
        buyDomains: null,
      },
      dowloadcsv: false,
      clickverif: false,
      empty: false,
      verifiedimport: false,
      pendingUpload: false,
      list: [],
      completeLoading: false,
      oliver_sale_id: "0",
      tabs: {
        // ids from task_history, check use unique values (EmailSyncList.vue and Performances.vue)
        1: {
          id: 1,
          name: "Mailboxes first sync",
          total: null,
        },
        2: {
          id: 2,
          name: "Mailboxes Re-sync",
          total: null,
        },
        3: {
          id: 3,
          name: "Blocked Mailboxes",
          total: null,
        },
        // 4: {
        //   id: 4,
        //   name: this.$t("lang.campaigns_dashboard.waiting"),
        //   total: null
        // },
        5: {
          id: 5,
          name: "Mailbox Creation",
          total: null,
        },
        6: {
          id: 6,
          name: this.$t("lang.label.failAuth"),
          total: null,
        },

        8: {
          id: 8,
          name: "Domain Config",
          total: null,
        },
        // 9: {
        //   id: 9,
        //   name: "Export apollo CSV",
        //   total: null,
        // },
        // 10: {
        //   id: 10,
        //   name: "Landing Page",
        //   total: null,
        // },
        // 11: {
        //   id: 11,
        //   name: "Delete Domain",
        //   total: null
        // },
        12: {
          id: 12,
          name: "Domains to buy",
          total: null,
        },
        13: {
          id: 13,
          name: "Missing Campaign Data",
          total: null,
        },
        14: {
          id: 14,
          name: "Contact Supply",
          total: null,
        },
        16: {
          id: 16,
          name: "Warmup",
          total: null,
        },
        17: {
          id: 17,
          name: "Commercial without emails",
          total: null,
        },
        18: {
          id: 18,
          name: "Copywriting chat",
          total: null,
        },
        // 22: {
        //   id: 22,
        //   name: "Config SMTP",
        //   total: null,
        // },
        23: {
          id: 23,
          name: "Missing Campaign Team",
          total: null,
        },
        24: {
          id: 24,
          name: "Not Prospecting Campaigns",
          total: null,
        },
        26: {
          id: 26,
          name: "Missing client AM",
          total: null,
        },
        27: {
          id: 27,
          name: "Burned domains",
          total: null,
        },
        28: {
          id: 28,
          name: "Phone lookup",
          total: null,
        },
        29: {
          id: 29,
          name: "Campaign slowing down",
          total: null,
        },
      },
      itemSelected2: 12,
      lastGetListRequest: 1,
      mailboxCreationFilter: "all",
      domainActionBusy: {},
    };
  },
  components: {
    ContactSupply,
    LoadingSpinner,
    Tabs,
    VideoToolToy,
    Modal,
    AgencyLandingPageList,
    DomainList,
    DeleteDomainList,
    AgencyBuyDomain,
    TargetMissingData,
    OwarmList,
    CommercialWithoutProspectors,
    ListTargetNotes,
    ConfigSmtp,
    ClientWithoutOliverSales,
    NotProspectingSales,
    ClientAttribution,
    BurnedDomains,
    PhoneLookup,
    OrderSlowingDown,
  },
  computed: {
    front() {
      return process.env.VUE_APP_FRONT_URL;
    },
    adminEmail() {
      return this.adminSync.admin_email || "";
    },
    adminPassword() {
      return this.adminSync.admin_password || "";
    },
    isAdminDataAvailable() {
      return (
        this.adminSync &&
        Object.keys(this.adminSync).length > 0
      );
    },
    displayedList() {
      let rows = this.list;
      if (this.itemSelected == 5 && this.mailboxCreationFilter !== "all") {
        rows = this.list.filter((row) => {
          const status = row.creation_status || "ok";
          return status === this.mailboxCreationFilter;
        });
      }
      if (this.itemSelected != 5) {
        return rows;
      }
      return this.groupMailboxRowsByDomain(rows);
    },
    mailboxFilterCounts() {
      const counts = {
        all: this.list.length,
        retrying: 0,
        exhausted: 0,
        abandoned: 0,
      };
      this.list.forEach((row) => {
        const status = row.creation_status || "ok";
        if (counts[status] !== undefined) {
          counts[status] += 1;
        }
      });
      return counts;
    },
  },
  created() {
    if (
      typeof this.$route.params.item !== "undefined" &&
      typeof this.$route.params.status !== "undefined"
    ) {
      this.noteStatus = this.$route.params.status;
      this.itemSelected = this.$route.params.item;
      //this.setInfoHeader(this.itemSelected)
      this.changeTab(this.itemSelected);
    } else {
      if (typeof this.$route.params.item !== "undefined") {
        this.itemSelected = this.$route.params.item;
        this.changeTab(this.itemSelected);
      }
    }
  },
  mounted() {
    // this.getDomainsToBuy();
    // this.getLandingPage();
    // this.getCalendarDomains();
    // this.getCsv("count");
    // this.getEmailSyncList("count", 1);
    // this.getEmailSyncList("count", 2);
    // //this.getEmailSyncList('count', 4);
    // this.getEmailSyncList("count", 5);
    // this.getEmailSyncList("count", 6);
    // this.getEmailSyncList("count", 3);
    // this.getTargetMissingData("count", 13);
    // this.getOwarmStats("count", 16);
    // this.getCommercialWithoutEmailsTotal("count", 17);
    //this.getTargetListNotesTotal("count", 18, this.noteStatus);
    // this.getEmailsConfigSmtp("count", 22);
    // this.getClientWithoutOliverSales("count", 23);
    // this.getNotProspectingSales("count", 24);
    // this.getTargetContactSupply('count', 25, 0);
    // this.getClientAttribution('count', 26);
    this.setHeader();
  },
  methods: {
    updateConfigSmtpTotal() {
      this.tabs[22].total = this.tabs[22].total - 1;
    },
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    setHeader() {

      if(this.$route.fullPath == '/syncemails/18/1'){
        this.setCurrentRoute({ page: "open-l1", label: "Open L1" });
        this.setInfoHeader();
      }else if (this.$route.fullPath == '/syncemails/18/2'){
        this.setCurrentRoute({ page: "open-l2", label: "Open L2" });
        this.setInfoHeader();
      }else if(this.$route.fullPath.includes('/syncemails/14/')){
        this.setCurrentRoute({ page: "critical-supply", label: "Critical Supply" });
        this.setInfoHeader();
      }
      
      switch(parseInt(this.$route.params.item)){
        case 1:
          this.setCurrentRoute({ page: "mailboxes-first-sync", label: "Mailboxes first sync" });
          break;
        case 2:
          this.setCurrentRoute({ page: "mailboxes-resync", label: "Mailboxes Re-sync" });
          break;
        case 12:
          this.setCurrentRoute({ page: "domains-to-buy", label: "Domains to buy" });
          break;
        case 5:
          this.setCurrentRoute({ page: "mailbox-creation", label: "Mailbox Creation" });
          break;
        case 3:
          this.setCurrentRoute({ page: "blocked-mailboxes", label: "Blocked Mailboxes" });
          break;
        case 8:
          this.setCurrentRoute({ page: "domain-config", label: "Domain Config" });
          break;
        case 13:
          this.setCurrentRoute({ page: "missing-order-data", label: "Missing Campaign Data" });
          break;
        case 16:
          this.setCurrentRoute({ page: "warmup", label: "Warmup" });
        break;
        case 23:
          this.setCurrentRoute({ page: "missing-order-team", label: "Missing Campaign Team" });
          break;
        case 24:
          this.setCurrentRoute({ page: "not-prospecting-orders", label: "Not Prospecting Campaigns" });
            break;
        case 26:
            this.setCurrentRoute({ page: "missing-client-am", label: "Missing Client AM" });
            break;
        case 28:
             this.setCurrentRoute({ page: "phone-lookup", label: "Phone Lookup" });
            break;
        default:
      }
    },
    getTittle() {
      if(this.$route.fullPath.includes('/syncemails/14/1')){
        return "Critical Supply";
      }
      if(this.$route.fullPath.includes('/syncemails/18/')){
        if(this.$route.fullPath.includes('/syncemails/18/1')){
          return "Open L1";
        }else if(this.$route.fullPath.includes('/syncemails/18/2')){
          return "Open L2";
        }
      }
      if(this.$route.fullPath.includes('/syncemails/')){
        return this.tabs[this.itemSelected].name;
      }
    },

    openModalZapmail(user_id) {
      const user = this.list.find((row) => row.id === user_id);
      this.isModalOpen = true;
      if (user) {
        this.userZapmail = user;
        this.$modal.show("zapmailVerificationModal");
        this.getZapmailVerificationCode(this.userZapmail.nylas_email_sync);
      }
    },

    beforeDestroy() {
      if (this.expireTimer) {
        clearInterval(this.expireTimer);
        this.expireTimer = null;
      }
      if (this.adminExpireTimer) {
        clearInterval(this.adminExpireTimer);
        this.adminExpireTimer = null;
      }
    },

    toggleAdminDetails() {
      this.showAdminDetails = !this.showAdminDetails;
      if (this.showAdminDetails && this.userZapmail) {
        this.adminLoading = true;
        this.getAdminAuthCode(this.userZapmail.nylas_email_sync);
      } else {
        // Detener el timer cuando se ocultan los detalles
        if (this.adminExpireTimer) {
          clearInterval(this.adminExpireTimer);
          this.adminExpireTimer = null;
        }
        this.adminOtpCode = "";
        this.adminSecondsToExpire = 0;
        this.adminLoading = false;
      }
    },

    getAdminAuthCode(email) {
      this.startAutoRefreshAdminCode(email);
    },

    startAutoRefreshAdminCode(email) {
      // Limpiar cualquier timer anterior
      if (this.adminExpireTimer) {
        clearInterval(this.adminExpireTimer);
        this.adminExpireTimer = null;
      }

      const refreshAdminCode = () => {
        if (!this.isModalOpen || !this.showAdminDetails) {
          console.log("Modal cerrado o admin details ocultos → petición cancelada");
          return;
        }

        this.adminLoading = true;
        workspaceService
          .getAdminDetails(email)
          .then((result) => {
            if (!this.isModalOpen || !this.showAdminDetails) return;
            this.adminSync = result;
            this.adminOtpCode = result.otpCode;
            this.adminSecondsToExpire = result.expiresIn;
            this.adminLoading = false;

            // Reiniciamos el countdown
            if (this.adminExpireTimer) clearInterval(this.adminExpireTimer);

            this.adminExpireTimer = setInterval(() => {
              if (!this.isModalOpen || !this.showAdminDetails) {
                clearInterval(this.adminExpireTimer);
                this.adminExpireTimer = null;
                return;
              }

              this.adminSecondsToExpire--;

              if (this.adminSecondsToExpire == 1) {
                refreshAdminCode();
              }
            }, 1000);
          })
          .catch((err) => {
            console.error("Error obteniendo admin details:", err);
            this.adminLoading = false;
          });
      };

      // Iniciar el primer código
      refreshAdminCode();
    },

    startAutoRefreshVerification(email) {
      // Limpiar cualquier timer anterior
      if (this.expireTimer) {
        clearInterval(this.expireTimer);
        this.expireTimer = null;
      }

      const refreshCode = () => {
        if (!this.isModalOpen) {
          console.log("Modal cerrado → petición cancelada");
          return;
        }

        workspaceService
          .getZapmailVerification(email)
          .then((result) => {
            if (!this.isModalOpen) return;
            this.otp_code = result.otpCode;
            this.seconds_to_expire = result.expiresIn;
            this.password_zapmail = result.password;
            this.codeReady = true;
            this.zapLoading = false;

            // Reiniciamos el countdown
            if (this.expireTimer) clearInterval(this.expireTimer);

            this.expireTimer = setInterval(() => {
              if (!this.isModalOpen) {
                clearInterval(this.expireTimer);
                this.expireTimer = null;
                return;
              }

              this.seconds_to_expire--;

              if (this.seconds_to_expire == 1 && this.codeReady) {
                refreshCode();
              }
            }, 1000);
          })
          .catch((err) => {
            this.zapLoading = false;
            this.$swal({
              type: "error",
              title: "Error",
              text: this.$t("lang.general.email_temporarily_unavailable"),
              confirmButtonText: this.$t("lang.button.ok"),
              confirmButtonColor: "#d33",
            }).then(() => {
              this.closeZapmailModal();
            });
          });
      };

      // Iniciar el primer código
      refreshCode();
    },

    getZapmailVerificationCode(email) {
      this.zapLoading = true;
      //email = "mathilde.bonneau@joinusdisruptons.com";
      this.startAutoRefreshVerification(email);
    },

    closeZapmailModal() {
      this.$modal.hide("zapmailVerificationModal");
      this.isModalOpen = false;
      if (this.expireTimer) {
        clearInterval(this.expireTimer);
        this.expireTimer = null;
      }
      if (this.adminExpireTimer) {
        clearInterval(this.adminExpireTimer);
        this.adminExpireTimer = null;
      }
      this.codeReady = false;
      this.otp_code = "";
      this.seconds_to_expire = 0;
      this.password_zapmail = "";
      this.zapLoading = false;
      this.userZapmail = null;
      this.showPassword = false;
      this.showPasswordAdmin = false;
      this.showAdminDetails = false;
      this.adminOtpCode = "";
      this.adminSecondsToExpire = 0;
      this.adminSync = {};
      this.adminLoading = false;
    },

    copyClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },

    getClientWithoutOliverSales(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;
      monitorService
        .getClientWithoutOliverSales(itemSelected, count)
        .then((result) => {
          if (count) {
            this.tabs[tab].total = result.result.count
              ? result.result.count
              : "0";
          }
        });
    },

    getNotProspectingSales(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;
      targetsService
        .getNotProspectingSales(itemSelected, count)
        .then((result) => {
          if (count) {
            this.tabs[tab].total = result.result.count
              ? result.result.count
              : "0";
          }
        });
    },

    getEmailsConfigSmtp(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;
      monitorService.getEmailsConfigSmtp(itemSelected, count).then((result) => {
        if (count) {
          this.tabs[tab].total = result.result.count
            ? result.result.count
            : "0";
        }
      });
    },

    getTargetListNotesTotal(count = 0, tab = null, status = 0) {
      const itemSelected = tab ? tab : this.itemSelected;
      targetsService
        .getTargetListNotes(itemSelected, count, status)
        .then((result) => {
          this.owarmStats = result.result;
          if (count) {
            this.tabs[tab].total = result.result.count
              ? result.result.count
              : "0";
          }
        });
    },

    getCommercialWithoutEmailsTotal(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;
      adminService
        .getTargetSalesWithoutProspectors(itemSelected, count)
        .then((result) => {
          this.owarmStats = result.result;
          if (count) {
            this.tabs[tab].total = result.result.count
              ? result.result.count
              : "0";
          }
        });
    },
    getOwarmStats(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;
      adminService.getListOwarm(itemSelected, count).then((result) => {
        this.owarmStats = result.result;
        if (count) {
          this.tabs[tab].total = result.result.count
            ? result.result.count
            : "0";
        }
      });
    },
    getTargetMissingData(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getTargetMissingData(itemSelected, count)
        .then((result) => {
          this.targetMissinDataItems = result;
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          }
        });
    },
    getListOwarm(count = 0, tab = null) {
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getTargetContactSupply(itemSelected, count)
        .then((result) => {
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          }
        });
    },
    getTargetContactSupply(count = 0, tab = null, oliver_sale_id = 0) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getTargetContactSupply(itemSelected, count, oliver_sale_id)
        .then((result) => {
          //this.targetMissinDataItems = result;
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          }

          this.completeLoading = true;
        });
    },
    getClientAttribution(count = 0, tab = null) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService
        .getClientAttribution(itemSelected, count)
        .then((result) => {
          //this.targetMissinDataItems = result;
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          }

          this.completeLoading = true;
        });
    },

    // getDomainFree(count = null){
    //   workspaceService.getFreeDomainsByClient(false, true, count)
    //   .then((result) => {
    //     this.tabs['11'].total = (result.count) ? result.count : '0';
    //   });
    // },
    closeModal(modal) {
      this.$modal.hide(modal);
    },
    openModal(modal) {
      this.$modal.show(modal);
    },
    verifyApollo() {
      this.clickverif = true;
      adminService.verifyApollo().then((result) => {
        this.clickverif = false;
        if (result.contacts.length == 0) {
          this.verifiedimport = false;
        } else {
          this.verifiedimport = true;
        }
      });
    },
    getCsv(count = null) {
      this.list = [];
      this.completeLoading = false;
      adminService.getCsv(count).then(
        (result) => {
          if (count) {
            this.tabs["9"].total = result.count ? result.count : "0";
          }
          this.empty = false;
          this.pendingUpload = false;
          if (result != "pending-upload" && result != "empty") {
            this.list = result;
          } else {
            if (result == "pending-upload") {
              this.pendingUpload = true;
            }
            if (result == "empty") {
              this.empty = true;
            }
          }

          this.completeLoading = true;
        },
        (error) => {
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );
    },
    downloadCSV(emails) {
      // Convierte los datos en formato CSV
      const csvData = emails.map((emailObj) => emailObj.email).join("\n");

      adminService.setCsv();
      // Crea un Blob con los datos CSV
      const blob = new Blob([csvData], { type: "text/csv" });

      // Crea un objeto URL para el Blob
      const blobUrl = URL.createObjectURL(blob);

      // Crea un enlace de descarga
      const a = document.createElement("a");
      a.href = blobUrl;

      const now = new Date();
      // Obtener el año, mes, día, hora y minutos
      let year = now.getFullYear();
      let month = String(now.getMonth() + 1).padStart(2, "0");
      let day = String(now.getDate()).padStart(2, "0");
      let hours = String(now.getHours()).padStart(2, "0");
      let minutes = String(now.getMinutes()).padStart(2, "0");
      let fechaDiaHora =
        year + "-" + month + "-" + day + "-" + hours + "-" + minutes;
      a.download = "emails-apollo-" + fechaDiaHora + ".csv";

      // Simula un clic en el enlace para iniciar la descarga
      a.click();

      // Libera el objeto URL
      URL.revokeObjectURL(blobUrl);
      this.getCsv();
      this.list = [];
      this.$forceUpdate();

      this.dowloadcsv = true;
    },
    getDataUserZapmailDetails(){
      workspaceService.getUserZapmailDetails().then((result) => {
        this.microsoftUnassigned = result.MICROSOFT.purchasedMailboxes - result.MICROSOFT.assignedMailboxes;
        this.walletBalance = result.GOOGLE.walletBalance;
        this.PlanType = result.MICROSOFT.activePlan;
      });
    },
    getEmailSyncList(count = null, tab = null) {
      if (!count) {
        this.lastGetListRequest = tab;
        this.completeLoading = false;
      }

      if(this.itemSelected == 5){
        this.getDataUserZapmailDetails();
      }

      const itemSelected = tab ? tab : this.itemSelected;
      adminService.getEmailSyncList(itemSelected, count).then(
        (result) => {
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          } else {
            if (itemSelected == this.lastGetListRequest) {
              this.list = result;
              this.completeLoading = true;
            }
          }
        },
        (error) => {
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );
    },

    changeTab(index) {
      this.itemSelected = this.tabs[index].id;
      // this.udpdateHeader("allbdr", this.tabs[index].name);
      // this.$emit("udpdateHeader", "allbdr", this.tabs[index].name )
      // if(this.itemSelected == 8){
      //   this.getCalendarDomains();
      // }else{
      if (this.itemSelected == 9) {
        this.getCsv();
      } else {
        if (this.itemSelected < 8) {
          this.getEmailSyncList(null, this.itemSelected);
        }
      }
      //}
    },
    connect(user) {
      usersService
        .getAuthenticationUrl(
          user.nylas_email_sync,
          user.name,
          user.lastname,
          user.id,
          "spark",
          user.provider
        )
        .then(
          (result) => {
            window.open(result, "_blank");
          },
          (error) => {
            this.$store.dispatch("alert/error", error, { root: true });
          }
        );
    },

    connectSpark(user) {
      if (user.provider == "gmail") {
        var scopes = [
          //"https://www.googleapis.com/auth/gmail.readonly",
          "https://www.googleapis.com/auth/userinfo.profile",
          "https://www.googleapis.com/auth/gmail.modify",
          "https://www.googleapis.com/auth/userinfo.email",
          "https://www.googleapis.com/auth/gmail.labels",
          "https://www.googleapis.com/auth/calendar",
        ];
        // var redirect_uri = "https://oliver-api.localhost.com/oauth/callback";
        //var redirect_uri = "https://app.oliverlist.com/dashboard";
        var redirect_uri = process.env.VUE_APP_FRONT_URL + "/dashboard";
        //console.log(redirect_uri);
        var client_id =
          "679504478551-85b7vh81acj9h8176g9fmpo0pomicgl3.apps.googleusercontent.com";
        var scope = scopes.join(" ");
        var auth_url = "https://accounts.google.com/o/oauth2/auth";
        auth_url += "?redirect_uri=" + encodeURIComponent(redirect_uri);
        auth_url += "&client_id=" + encodeURIComponent(client_id);
        auth_url += "&scope=" + encodeURIComponent(scope);
        auth_url += "&approval_prompt=force";
        auth_url += "&access_type=offline";
        auth_url += "&response_type=code";
        auth_url += "&login_hint=" + user.nylas_email_sync;

        window.open(auth_url, "_blank");
      } else {
        let client_id = "0d136df4-3c69-4c23-b7b9-54217c864e0c"; //APP OLIVER
        let redirect_uri = process.env.VUE_APP_FRONT_URL + "/dashboard";
        let scope =
          "Calendars.Read.Shared Calendars.ReadWrite Calendars.ReadWrite.Shared Contacts.Read Contacts.ReadWrite Mail.Read Mail.ReadWrite Mail.Send OnlineMeetings.ReadWrite  User.Read profile openid offline_access";
        let state = Math.random().toString(36).substring(7);
        let auth_url =
          "https://login.microsoftonline.com/common/oauth2/v2.0/authorize" +
          "?client_id=" +
          encodeURIComponent(client_id) +
          "&response_type=code" +
          "&redirect_uri=" +
          encodeURIComponent(redirect_uri) +
          "&scope=" +
          encodeURIComponent(scope) +
          "&state=" +
          encodeURIComponent(state) +
          "&login_hint=" +
          user.nylas_email_sync;

        window.open(auth_url, "_blank");
      }
    },

    generateTabs() {
      for (let index = 0; index < 30; index++) {
        this.connectSpark(this.list[index]);
      }
    },

    getDomainsToBuy() {
      workspaceService.getDomainsToBuy("count").then((result) => {
        this.tabs["12"].total = result.count;
      });
    },

    getLandingPage() {
      adminService.getLandingPage("count").then((res) => {
        const { error, result } = res;
        if (!error) this.tabs["10"].total = result.count ? result.count : "0";
      });
    },

    getCalendarDomains() {
      this.completeLoading = false;
      workspaceService
        .getWorkspaceDomains("", "all_inactive", true)
        .then((res) => {
          this.tabs["8"].total = res.count ? res.count : "0";
          this.completeLoading = true;
        });
    },
    taskOpenHoursClass(task_open_hours) {
      if (this.itemSelected == 6 && task_open_hours < 24) {
        return "badge-warning";
      } else if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
    creationStatusClass(status) {
      if (status === "retrying") return "badge-warning";
      if (status === "exhausted") return "badge-danger";
      if (status === "abandoned") return "badge-secondary";
      return "badge-success";
    },
    retryBackoffHours(attempts) {
      const n = parseInt(attempts, 10) || 0;
      if (n <= 1) return 3;
      if (n === 2) return 6;
      if (n === 3) return 12;
      return 24;
    },
    parseMysqlDate(value) {
      if (!value) return null;
      const parsed = new Date(String(value).replace(" ", "T"));
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    nextRetryAt(row) {
      const lastAttempt = this.parseMysqlDate(row.error_last_attempt);
      if (!lastAttempt) return null;
      const next = new Date(lastAttempt.getTime());
      next.setHours(next.getHours() + this.retryBackoffHours(row.error_attempts));
      return next;
    },
    nextLookupAt(row) {
      const lastAttempt = this.parseMysqlDate(row.error_last_attempt);
      if (!lastAttempt) return null;
      const next = new Date(lastAttempt.getTime());
      next.setHours(next.getHours() + 3);
      return next;
    },
    errorText(row) {
      return String(row.error || "").toLowerCase();
    },
    isMax5LimitError(row) {
      return this.errorText(row).indexOf("max 5 mailboxes") !== -1;
    },
    isAccountCapacityWait(row) {
      const error = this.errorText(row);
      return (
        error.indexOf("have enough mailboxes") !== -1 ||
        error.indexOf("insufficient subscription capacity") !== -1 ||
        error.indexOf("mailboxes left to assign") !== -1
      );
    },
    isQuotaWait(row) {
      return this.isMax5LimitError(row) || this.isAccountCapacityWait(row);
    },
    isDomainIdNotFoundWait(row) {
      return this.errorText(row).indexOf("domain id not found") !== -1;
    },
    isNonAttemptWait(row) {
      return this.isQuotaWait(row) || this.isDomainIdNotFoundWait(row);
    },
    formatDayMonth(value) {
      const parsed = this.parseMysqlDate(value);
      if (!parsed) return "";
      const day = parsed.getDate();
      const month = String(parsed.getMonth() + 1).padStart(2, "0");
      return day + "/" + month;
    },
    quotaReleaseLabel(row) {
      if (!row.quota_release_at) return "";
      return "Seats release " + this.formatDayMonth(row.quota_release_at);
    },
    mailboxWaitMessage(row) {
      const status = row.creation_status || "ok";
      if (status === "exhausted" || status === "abandoned") {
        return "";
      }
      const seatLabel = this.isAccountCapacityWait(row)
        ? "Zapmail account seats"
        : "Zapmail seat release";
      // Account capacity is not tied to this domain's billing: retry on quota_retry_at.
      const billingAt = this.isAccountCapacityWait(row)
        ? null
        : this.parseMysqlDate(row.quota_release_at);
      if (billingAt && (this.isQuotaWait(row) || row.deletion_in_progress > 0)) {
        const label = this.formatDayMonth(billingAt);
        if (billingAt > new Date()) {
          return "Next try on " + label + " (" + seatLabel + ")";
        }
        return "Seat release date " + label + " reached — waiting generator";
      }
      const retryAt = this.parseMysqlDate(row.quota_retry_at);
      if (this.isQuotaWait(row) && retryAt && retryAt > new Date()) {
        return "Next try on " + this.formatDayMonth(retryAt) + " (" + seatLabel + ")";
      }
      if (this.isQuotaWait(row)) {
        return "Waiting " + seatLabel;
      }
      if (this.isDomainIdNotFoundWait(row)) {
        const lookupAt = this.nextLookupAt(row);
        if (lookupAt && lookupAt > new Date()) {
          const hoursLeft = Math.max(1, Math.ceil((lookupAt - new Date()) / 3600000));
          return "Next lookup in ~" + hoursLeft + "h (Zapmail domain not listed yet)";
        }
        return "Waiting Zapmail domain listing (retry every 3h)";
      }
      const attempts = parseInt(row.error_attempts, 10) || 0;
      const nextRetry = this.nextRetryAt(row);
      if (attempts > 0 && nextRetry && nextRetry > new Date()) {
        const hoursLeft = Math.max(1, Math.ceil((nextRetry - new Date()) / 3600000));
        const backoff = this.retryBackoffHours(attempts);
        return (
          "Next retry in ~" +
          hoursLeft +
          "h (backoff " +
          backoff +
          "h after attempt " +
          attempts +
          "/10)"
        );
      }
      return "Waiting generator process (every 3 minutes)";
    },
    mailboxWaitClass(row) {
      const status = row.creation_status || "ok";
      if (status === "retrying" && this.isNonAttemptWait(row)) return "text-info";
      if (status === "retrying") return "text-warning";
      const attempts = parseInt(row.error_attempts, 10) || 0;
      const nextRetry = this.nextRetryAt(row);
      if (this.isNonAttemptWait(row)) return "text-info";
      if (attempts > 0 && nextRetry && nextRetry > new Date()) {
        return "text-warning";
      }
      return "text-success";
    },
    groupMailboxRowsByDomain(rows) {
      const groups = [];
      const indexByDomain = {};
      rows.forEach((row) => {
        const domain = row.domain || `__row_${groups.length}`;
        if (indexByDomain[domain] === undefined) {
          indexByDomain[domain] = groups.length;
          groups.push([]);
        }
        groups[indexByDomain[domain]].push(row);
      });
      return groups.reduce((acc, group) => acc.concat(group), []);
    },
    isFirstDomainRow(row, index) {
      if (!row.domain) {
        return true;
      }
      const prev = this.displayedList[index - 1];
      return !prev || prev.domain !== row.domain;
    },
    retryDomainCreation(domain) {
      if (!domain) return;
      if (!window.confirm("Retry mailbox creation for " + domain + "?")) {
        return;
      }
      this.$set(this.domainActionBusy, domain, true);
      workspaceService.retryZapmailDomainCreation(domain).then(
        () => {
          this.$set(this.domainActionBusy, domain, false);
          this.getEmailSyncList(null, this.itemSelected);
        },
        (error) => {
          this.$set(this.domainActionBusy, domain, false);
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );
    },
    abandonDomainCreation(domain) {
      if (!domain) return;
      if (
        !window.confirm(
          "Abandon mailbox creation for " +
            domain +
            "? Daily alerts will stop. Pending users stay on this sales representative."
        )
      ) {
        return;
      }
      this.$set(this.domainActionBusy, domain, true);
      workspaceService.abandonZapmailDomainCreation(domain).then(
        () => {
          this.$set(this.domainActionBusy, domain, false);
          this.getEmailSyncList(null, this.itemSelected);
        },
        (error) => {
          this.$set(this.domainActionBusy, domain, false);
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );
    },
  },
};
</script>

<style scoped>
/* Mantener el tamaño del modal fijo incluso cuando se abre la consola */
.zapmail-modal-fixed :deep(.v--modal-box) {
  min-width: 500px !important;
  width: 500px !important;
}
</style>
